import React from "react"
import InfoHeaderPerson from "./InfoHeaderPerson";
import InfoHeaderDriver from "./InfoHeaderDriver";
import InfoHeaderLegalEntity from "./InfoHeaderLegalEntity";
import InfoHeaderVehicle from "./InfoHeaderVehicle";
import InfoHeaderContract from "./InfoHeaderContract";
import InfoHeaderWizard from "./InfoHeaderWizard";
import InfoHeaderAudienceLead from "./InfoHeaderAudienceLead";
import InfoHeaderAdvertisingCost from "./InfoHeaderAdvertisingCost";
import InfoHeaderBudget from "./InfoHeaderBudget";
import InfoHeaderCampaign from "./InfoHeaderCampaign";
import InfoHeaderCampaignLeadOperator from "./InfoHeaderCampaignLeadOperator";
import InfoHeaderCampaignOperator from "./InfoHeaderCampaignOperator";
import InfoHeaderBudgetAndGoal from "./InfoHeaderBudgetAndGoal";
import InfoHeaderVehicleSeller from "./InfoHeaderVehicleSeller";

const InfoHeader = (params) => {

    const { view, item, control, title, subtitle } = params;

    if (view === 'person') {
        return <InfoHeaderPerson
            {...params}
            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'driver') {
        return <InfoHeaderDriver
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'legalEntity') {
        return <InfoHeaderLegalEntity
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'vehicle') {
        return <InfoHeaderVehicle
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'vehicle_seller') {
        return <InfoHeaderVehicleSeller
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }
    if (view === 'contract') {
        return <InfoHeaderContract
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'wizard') {
        return <InfoHeaderWizard
            {...params}

            view={view}
            title={title}
            subtitle={subtitle}
        />
    }

    if (view === 'audiencelead') {
        return <InfoHeaderAudienceLead
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

        if (view === 'campaignleadoperator') {
        return <InfoHeaderCampaignLeadOperator
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'advertisingcost') {
        return <InfoHeaderAdvertisingCost
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'budget') {
        return <InfoHeaderBudget
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'budgetAndGoal') {
        return <InfoHeaderBudgetAndGoal
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }

    if (view === 'campaign') {
        return <InfoHeaderCampaign
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }
    if (view === 'campaignoperator') {
        return <InfoHeaderCampaignOperator
            {...params}

            view={view}
            item={item}
            control={control}
        />
    }
};

export default InfoHeader
